$(document).ready(function(){
  
  var searchParams = new URLSearchParams(window.location.search);
  var p_type = searchParams.get('pt');
  var p_name = searchParams.get('pn');
  if(p_name != null){
     $(".first_clickyboxes_product li a").removeClass('active');
     $('.first_clickyboxes_product li a').each(function() {
          var data_tag = $.trim($(this).attr('data-firstindex'));
          if(data_tag == p_type){
             $(this).addClass('active');
          }
      });
      var first_product_option = $.trim($('.first_clickyboxes_product li').find(".active").attr('data-value'));
      $(".second_clickyboxes_product li").removeClass('other_option');
      $('.second_clickyboxes_product li a').each(function() {
          var data_tag = $.trim($(this).attr('data-tags'));
          if(data_tag == first_product_option){
             $(this).closest('li').addClass('other_option');
          }
      });
      $('.second_clickyboxes_product li.other_option a[data-secondindex='+p_name+']').addClass("active");
      var prodcut_title = $.trim($('.second_clickyboxes_product li.other_option a[data-secondindex='+p_name+']').text());
      $(document).find(".product-detail__title").text(prodcut_title);
      var prodcut_price = $.trim($('.second_clickyboxes_product li.other_option a[data-secondindex='+p_name+']').attr('data-price'));
      $(document).find("span.theme-money.large-title").text(prodcut_price);
      var prodcut_img = $.trim($('.second_clickyboxes_product li.other_option a[data-secondindex='+p_name+']').attr('data-images'));
      $(document).find(".rimage__image_data").attr("src",prodcut_img);
      var prodcut_varId = $.trim($('.second_clickyboxes_product li.other_option a[data-secondindex='+p_name+']').attr('data-varid'));
      $('#cus_option_selection').find(":selected").val(prodcut_varId);
      $('#pay_varID').val(prodcut_varId);
      var prodcut_qty = $.trim($('.second_clickyboxes_product li.other_option a[data-secondindex='+p_name+']').attr('data-continue'));
      if(prodcut_qty == 'out_of_stock'){
        $('.btn--subtle-hover').css({"pointer-events": "none", "opacity": ".5"});
        $('.btn--subtle-hover span').text('Sold Out');
        $('.btn--subtle-hover').attr("disabled", "disabled");
      }else{
         $('.btn--subtle-hover').css({"pointer-events": "unset", "opacity": "1"});
         $('.btn--subtle-hover span').text('Add to Cart');
         $('.btn--subtle-hover').removeAttr("disabled");
      }
      var prodcut_id = $.trim($('.second_clickyboxes_product li.other_option a[data-secondindex='+p_name+']').attr('data-proid'));
     $(document).find("#shopify-product-reviews").attr('data-id',prodcut_id);
     $(document).find(".spr-summary-actions-newreview").attr("onclick","SPR.toggleForm("+prodcut_id+");return false");
     $(document).find('.new-review-form input[name="product_id"]').attr('value',prodcut_id);
       $(document).find(".comapre_data").each(function() {
           var prodcut_findId = $(this).attr('data-product');
           if(prodcut_findId == prodcut_id){
             $(this).show();
           }else{
             $(this).hide();
           }
        });
        $('.notes_meta').each(function() {
          var prodcut_meta = $(this).attr('data-prodcut');
          if(prodcut_meta == prodcut_id){
            $(this).show();
          }else{
            $(this).hide();
          }
        });
       var prodcut_handle = $.trim($('.second_clickyboxes_product li.other_option a[data-secondindex='+p_name+']').attr('data-value'));
       var newurl = window.location.protocol + '//' + window.location.host +'/products/'+prodcut_handle;
       history.pushState({path: newurl}, '', newurl);
    
  }else{
 
      var first_product_option = $.trim($('.first_clickyboxes_product li').find(".active").attr('data-value'));
      if(first_product_option != ''){
         $(".second_clickyboxes_product li").removeClass('other_option');
         $('.second_clickyboxes_product li a').each(function() {
              var data_tag = $.trim($(this).attr('data-tags'));
              if(data_tag == first_product_option){
                 $(this).closest('li').addClass('other_option');
              }
         });
         $(".second_clickyboxes_product li.other_option:first a").addClass('active');
          var prodcut_title = $.trim($(".second_clickyboxes_product li.other_option:first a").text());
          $(document).find(".product-detail__title").text(prodcut_title);
          var prodcut_price = $.trim($(".second_clickyboxes_product li.other_option:first a").attr('data-price'));
          $(document).find("span.theme-money.large-title").text(prodcut_price);
          var prodcut_img = $.trim($(".second_clickyboxes_product li.other_option:first a").attr('data-images'));
          $(document).find(".rimage__image_data").attr("src",prodcut_img);
          var prodcut_varId = $.trim($(".second_clickyboxes_product li.other_option:first a").attr('data-varid'));
          $('#cus_option_selection').find(":selected").val(prodcut_varId);
          $('#pay_varID').val(prodcut_varId);
            var prodcut_qty = $.trim($(".second_clickyboxes_product li.other_option:first a").attr('data-continue'));
            // if(prodcut_qty == 'out_of_stock'){
            //   $('.btn--subtle-hover').css({"pointer-events": "none", "opacity": ".5"});
            //   $('.btn--subtle-hover span').text('Sold Out');
            //   $('.btn--subtle-hover').attr("disabled", "disabled");
            // }else{
            //    $('.btn--subtle-hover').css({"pointer-events": "unset", "opacity": "1"});
            //    $('.btn--subtle-hover span').text('Add to Cart');
            //    $('.btn--subtle-hover').removeAttr("disabled");
            // }
            var prodcut_id = $.trim($(".second_clickyboxes_product li.other_option:first a").attr('data-proid'));
            $(document).find("#shopify-product-reviews").attr('data-id',prodcut_id);
            $(document).find(".spr-summary-actions-newreview").attr("onclick","SPR.toggleForm("+prodcut_id+");return false");
            $(document).find('.new-review-form input[name="product_id"]').attr('value',prodcut_id);

            $(document).find(".comapre_data").each(function() {
               var prodcut_findId = $(this).attr('data-product');
               if(prodcut_findId == prodcut_id){
                 $(this).show();
               }else{
                 $(this).hide();
               }
            });
            $('.notes_meta').each(function() {
              var prodcut_meta = $(this).attr('data-prodcut');
              if(prodcut_meta == prodcut_id){
                $(this).show();
              }else{
                $(this).hide();
              }
            });
        
            var prodcut_handle = $.trim($('.second_clickyboxes_product li.other_option:first a').attr('data-value'));
            var newurl = window.location.protocol + '//' + window.location.host +'/products/'+prodcut_handle;
            history.pushState({path: newurl}, '', newurl);
       } 
  }
   
  $(document).on("click", ".first_clickyboxes_product li a", function() {
    
     $(".first_clickyboxes_product li a").removeClass('active');
     $(".second_clickyboxes_product li a").removeClass('active');
     $(".second_clickyboxes_product li").removeClass('other_option');
     $(this).addClass('active');
     var first_data_option = $(this).attr('data-value');
       $('.second_clickyboxes_product li a').each(function() {
          var data_tag = $.trim($(this).attr('data-tags'));
          if(data_tag == first_data_option){
             $(this).closest('li').addClass('other_option');
          }
       });

    
      $(".second_clickyboxes_product li.other_option:first a").addClass('active');
      var prodcut_title = $.trim($(".second_clickyboxes_product li.other_option:first a").text());
      $(document).find(".product-detail__title").text(prodcut_title);
      var prodcut_price = $.trim($(".second_clickyboxes_product li.other_option:first a").attr('data-price'));
      $(document).find("span.theme-money.large-title").text(prodcut_price);
      var prodcut_img = $.trim($(".second_clickyboxes_product li.other_option:first a").attr('data-images'));
      $(document).find(".rimage__image_data").attr("src",prodcut_img);
      var prodcut_varId = $.trim($(".second_clickyboxes_product li.other_option:first a").attr('data-varid'));
      $('#cus_option_selection').find(":selected").val(prodcut_varId);
      $('#pay_varID').val(prodcut_varId);
      var prodcut_qty = $.trim($(".second_clickyboxes_product li.other_option:first a").attr('data-continue'));
        // if(prodcut_qty == 'out_of_stock'){
        //     $('.btn--subtle-hover').css({"pointer-events": "none", "opacity": ".5"});
        //     $('.btn--subtle-hover span').text('Sold Out');
        //     $('.btn--subtle-hover').attr("disabled", "disabled");
        //   }else{
        //      $('.btn--subtle-hover').css({"pointer-events": "unset", "opacity": "1"});
        //      $('.btn--subtle-hover span').text('Add to Cart');
        //      $('.btn--subtle-hover').removeAttr("disabled");
        //   }

      var prodcut_id = $.trim($(".second_clickyboxes_product li.other_option:first a").attr('data-proid'));
    
      $(document).find("#shopify-product-reviews").attr('data-id',prodcut_id);
      $(document).find(".spr-summary-actions-newreview").attr("onclick","SPR.toggleForm("+prodcut_id+");return false");
      $(document).find('.new-review-form input[name="product_id"]').attr('value',prodcut_id);
    
          $(document).find(".comapre_data").each(function() {
                   var prodcut_findId = $(this).attr('data-product');
                   if(prodcut_findId == prodcut_id){
                     $(this).show();
                   }else{
                     $(this).hide();
                   }
            });
    
            $('.notes_meta').each(function() {
              var prodcut_meta = $(this).attr('data-prodcut');
              if(prodcut_meta == prodcut_id){
                $(this).show();
              }else{
                $(this).hide();
              }
            });
      
      var prodcut_handle = $.trim($('.second_clickyboxes_product li.other_option:first a').attr('data-value'));
      var product_type = $(this).attr('data-firstindex');
      var prodcut_name = $.trim($(".second_clickyboxes_product li.other_option:first a").attr('data-secondindex'));
      var newurl = window.location.protocol + '//' + window.location.host +'/products/'+prodcut_handle+'?pt='+product_type+'&pn='+prodcut_name;
      window.history.replaceState({path: newurl}, '', newurl);
     
  });
  
  $(document).on("click", ".second_clickyboxes_product li a", function() {
     $(".second_clickyboxes_product li a").removeClass('active');
     $(".second_clickyboxes_product li").removeClass('other_option');
     $(this).addClass('active');
     var data_tag = $.trim($(this).attr('data-tags'));
       $('.second_clickyboxes_product li a').each(function() {
        var data_tag_prodcut = $.trim($(this).attr('data-tags'));
        if(data_tag_prodcut == data_tag){
           $(this).closest('li').addClass('other_option');
        }
      });
      var prodcut_title = $.trim($(this).text());
      $(document).find(".product-detail__title").text(prodcut_title);
      var prodcut_price = $.trim($(this).attr('data-price'));
      $(document).find("span.theme-money.large-title").text(prodcut_price);
      var prodcut_img = $.trim($(this).attr('data-images'));
      $(document).find(".rimage__image_data").attr("src",prodcut_img);
      var prodcut_varId = $.trim($(this).attr('data-varid'));
      $('#cus_option_selection').find(":selected").val(prodcut_varId);
      $('#pay_varID').val(prodcut_varId);
       var prodcut_qty = $.trim($(this).attr('data-continue'));
       // if(prodcut_qty == 'out_of_stock'){
       //    $('.btn--subtle-hover').css({"pointer-events": "none", "opacity": ".5"});
       //    $('.btn--subtle-hover span').text('Sold Out');
       //    $('.btn--subtle-hover').attr("disabled", "disabled");
       //  }else{
       //     $('.btn--subtle-hover').css({"pointer-events": "unset", "opacity": "1"});
       //     $('.btn--subtle-hover span').text('Add to Cart');
       //     $('.btn--subtle-hover').removeAttr("disabled");
       //  }
      var prodcut_id = $.trim($(this).attr('data-proid'));

      
      $(document).find("#shopify-product-reviews").attr('data-id',prodcut_id);
      $(document).find(".spr-summary-actions-newreview").attr("onclick","SPR.toggleForm("+prodcut_id+");return false");
      $(document).find('.new-review-form input[name="product_id"]').attr('value',prodcut_id);
    
      $(document).find(".comapre_data").each(function() {
           var prodcut_findId = $(this).attr('data-product');
           if(prodcut_findId == prodcut_id){
             $(this).show();
           }else{
             $(this).hide();
           }
      });
      $('.notes_meta').each(function() {
          var prodcut_meta = $(this).attr('data-prodcut');
          if(prodcut_meta == prodcut_id){
            $(this).show();
          }else{
            $(this).hide();
          }
        });

      var prodcut_handle = $.trim($(this).attr('data-handle'));
      var product_type = $('.first_clickyboxes_product').find('.active').attr('data-firstindex');
      var prodcut_name = $(this).attr('data-secondindex');
      var newurl = window.location.protocol + '//' + window.location.host +'/products/'+prodcut_handle+'?pt='+product_type+'&pn='+prodcut_name;
      window.history.replaceState({path: newurl}, '', newurl);

  });

 
$(".itg_blog_image_sec").slick({
     arrows: true,
     slidesToShow: 4,
     infinite:true,
     slidesToScroll: 1,
     prevArrow: '<div class="previus"><button class="btn--plain prev icon feather-icon slick-arrow" aria-label="Previous" aria-disabled="false" style=""><svg aria-hidden="true" focusable="false" role="presentation" class="icon feather-arrow-left" viewBox="0 0 24 24"><path d="M19 12H5M12 19l-7-7 7-7"></path></svg></button></div>',
     nextArrow: '<div class="next"><button class="btn--plain next icon feather-icon slick-arrow" aria-label="Previous" style="" aria-disabled="false"><svg aria-hidden="true" focusable="false" role="presentation" class="icon feather-arrow-right" viewBox="0 0 24 24"><path d="M5 12h14M12 5l7 7-7 7"></path></svg></button></div>',
     autoplay: false,
     autoplaySpeed:1500,
     responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow:3
          }
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2,
             centerMode: false,
             centerPadding: '0'
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow:1,
             centerMode: false,
             centerPadding: '0'
          }
        }
      ]
    });
  
});